export default __webpack_public_path__ + "static/media/t-deposit.a9346d96.webp";